import * as React from "react";
import LoginForm from "./../Forms/LoginForm";
import { connect } from "react-redux";
import * as ViewManagementModule from "./../../Modules/ViewManagementModule";
import * as UserModule from "./../../Modules/UserModule";
import * as InvestmentModule from "./../../Modules/InvestmentModule";
import { RootState } from "./../../Store/Reducers/_RootReducer";
import { history } from "src/App";
import FacebookLogin from "react-facebook-login";
import { Link } from "react-router-dom";

type DispatchedP = {
  hideFooter: () => void;
  hideHeader: () => void;
  loginUser: (username: string, password: string, openPDF: boolean, facebook?: boolean, apple?: any) => void;
  showPopup: (type: string) => void;
  getPDF: (selectedPDF: string) => void;
};
type ConnectedP = {
  userStore: UserModule.Types.UserStore;
};
type P = {
  openPDF: boolean;
  selectedPDF: string;
};

class Login extends React.Component<DispatchedP & ConnectedP & P, any> {
  constructor(props: DispatchedP & ConnectedP & P) {
    super(props);
  }

  public componentWillMount() {
    if (this.props.userStore.user && !this.props.openPDF) {
      history.push("/dashboard");
    }
  }

  public componentDidMount() {
    window.AppleID.auth.init({
      clientId: `${process.env.REACT_APP_APPLE_CLIENT_ID}`,
      redirectURI: `${process.env.REACT_APP_DOMAIN_URL}/dashboard/login`,
      locale: "pl_PL",
      scope: "name email",
      usePopup: true,
    });
  }

  public handleSubmit = async (formData) => {
    await this.props.loginUser(formData.username, formData.password, this.props.openPDF);
    if (this.props.userStore.isUserLogged && this.props.openPDF) {
      this.props.getPDF(this.props.selectedPDF);
    }
  };
  public responseFacebook = async (response) => {
    await this.props.loginUser(response.email, response.accessToken, this.props.openPDF, true);
  };
  public signInByApple = async (e) => {
    e.preventDefault();
    await window.AppleID.auth.signIn().then(
      async (data) => {
        console.log("Dane z apple:", data);
        data.authorization = {
          ...data.authorization,
          redirect_uri: `${process.env.REACT_APP_DOMAIN_URL}/dashboard/login`,
        };
        await this.props.loginUser("", "", this.props.openPDF, false, {
          appleFlag: true,
          data,
        });
      },
      function (err) {
        console.log(err);
      }
    );
  };
  public render() {
    return (
      <div className='login'>
        <div className='login__inner' style={{ marginTop: !this.props.openPDF ? "60px" : null }}>
          <h2>{!this.props.openPDF && "Logowanie"}</h2>
          <div className='center'>
            <FacebookLogin
              appId={process.env.REACT_APP_FB_APP_ID}
              autoLoad={false}
              fields='name,email,picture,first_name,last_name'
              // onClick={this.componentClicked}
              callback={this.responseFacebook}
              icon='fa-facebook'
              textButton='Zaloguj przez Facebooka'
              isMobile={false}
              disableMobileRedirect={true}
            />
          </div>
          <p className='center'>lub</p>
          <div
            id='appleid-signin'
            className='login__apple-btn'
            data-color='black'
            data-border='true'
            data-type='sign-in'
            onClick={this.signInByApple}
          />
          <p className='center'>lub</p>
          <LoginForm onSubmit={this.handleSubmit} />
          <a className='login__password-forget' onClick={() => this.props.showPopup("resetPassword")}>
            Nie pamiętasz hasła?
          </a>
          <p className='login__sign-up'>Nie masz konta?</p>
          <Link to={"/register"}>
            <button className='btn btn--main btn--dark'>Zarejestruj się</button>
          </Link>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps: DispatchedP = {
  hideFooter: () => ViewManagementModule.Actions.hideFooter(),
  hideHeader: () => ViewManagementModule.Actions.hideHeader(),
  loginUser: (username: string, password: string, openPDF: boolean, facebook?: boolean, apple?: any) =>
    UserModule.Actions.loginUser(username, password, openPDF, facebook, apple),
  showPopup: (type: string) => ViewManagementModule.Actions.showPopup(type),
  getPDF: (selectedPDF: string) => InvestmentModule.Actions.getPDF(selectedPDF),
};

function mapStateToProps(state: RootState) {
  return {
    userStore: state.userStore,
    selectedPDF: state.investmentStore.selectedPDF,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/components/Layout/Login.tsx